import { render } from "./ProblemSection.vue?vue&type=template&id=7805ab32&scoped=true"
import script from "./ProblemSection.vue?vue&type=script&lang=js"
export * from "./ProblemSection.vue?vue&type=script&lang=js"

import "./ProblemSection.vue?vue&type=style&index=0&id=7805ab32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7805ab32"]])

export default __exports__